// extracted by mini-css-extract-plugin
export default {"label":"SourceEditPage_label__7YAdj","root":"SourceEditPage_root__nEa3b","errorMessage":"SourceEditPage_errorMessage__Ov74T"};